import Layout from '@/layout/layout.vue';
import Vue from 'vue';
import Router, { RouteConfig } from 'vue-router';

Vue.use(Router);

export const constantRoutes: RouteConfig[] = [
    {
        path: '/',
        component: Layout,
        name: 'home',
        redirect: { name: 'home' },
        children: [
            {
                path: 'home',
                name: 'home',
                meta: { title: '在职教职工选择体检医院系统', keepAlive: false },
                component: () => import('@/views/home/home.vue'),
            },
            {
                path: 'profile',
                name: 'profile',
                meta: { title: '基础信息确认' },
                component: () => import('@/views/profile/profile.vue'),
            },
            {
                path: 'form',
                name: 'form',
                meta: { title: '选择体检医院' },
                component: () => import('@/views/form/form.vue'),
            },
            {
                path: 'appointment',
                name: 'appointment',
                meta: { title: '我的体检医院' },
                component: () => import('@/views/appointment/appointment.vue'),
            },
            {
                path: 'NoAuthentication',
                name: 'NoAuthentication',
                meta: { title: '你不在体检名单中' },
                component: () => import('@/views/NoAuthentication.vue'),
            },
        ],
    },
];

export const asyncRoutes: RouteConfig[] = [];

const createRouter = () => new Router({
    // mode: 'history',  // Disabled due to Github Pages doesn't support this, enable this if you need.
    scrollBehavior: (to, from, savedPosition) => {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    },
    base: process.env.BASE_URL,
    routes: constantRoutes,
});

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    (router as any).matcher = (newRouter as any).matcher; // reset router
}

export default router;
